/*
 * Keeps the legitimate acquisition source across the external MitID age-check
 * redirect. This is an analytics/reporting aid only; it must never be used for
 * access control or for deciding whether a customer is old enough to buy.
 */
(function () {
  'use strict';

  var CALLBACK_PATH = '/a/eid/complete';
  var STORAGE_KEY = 'devinos_attribution_repair_v1';
  var MAX_AGE_MS = 2 * 60 * 60 * 1000;
  var TRACKING_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'gclid', 'fbclid', 'msclkid', 'ttclid', 'sclid'
  ];

  function storage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      try { return window.localStorage; } catch (ignored) { return null; }
    }
  }

  function trackingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    try {
      if (typeof privacy.marketingAllowed === 'function') {
        return privacy.marketingAllowed();
      }
      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  function sameSite(url) {
    try {
      var host = new URL(url).hostname.toLowerCase();
      var current = window.location.hostname.toLowerCase();
      return host === current || host === 'www.' + current || host.endsWith('.devinos.dk');
    } catch (error) {
      return false;
    }
  }

  function classifyReferrer(referrer) {
    if (!referrer || sameSite(referrer)) return null;
    try {
      var host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, '');
      if (/google\./.test(host)) return { source: 'google', medium: 'organic' };
      if (/bing\./.test(host)) return { source: 'bing', medium: 'organic' };
      if (/duckduckgo\./.test(host)) return { source: 'duckduckgo', medium: 'organic' };
      if (/(^|\.)facebook\.com$|(^|\.)instagram\.com$|(^|\.)l\.facebook\.com$/.test(host)) {
        return { source: host.indexOf('instagram') >= 0 ? 'instagram' : 'facebook', medium: 'social' };
      }
      if (/(^|\.)tiktok\.com$/.test(host)) return { source: 'tiktok', medium: 'social' };
      return { source: host, medium: 'referral' };
    } catch (error) {
      return null;
    }
  }

  function read() {
    var store = storage();
    if (!store) return null;
    try {
      var value = JSON.parse(store.getItem(STORAGE_KEY) || 'null');
      return value && Date.now() - value.savedAt < MAX_AGE_MS ? value : null;
    } catch (error) {
      return null;
    }
  }

  function write(value) {
    var store = storage();
    if (!store) return;
    try { store.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (error) {}
  }

  function capture() {
    if (!trackingAllowed()) return;

    var params = new URLSearchParams(window.location.search);
    var hasTracking = TRACKING_KEYS.some(function (key) { return params.has(key); });
    var source = params.get('utm_source');
    var medium = params.get('utm_medium');
    var inferred = classifyReferrer(document.referrer);

    var existing = read();
    if (existing) {
      // Keep first-touch attribution, but always return to the latest page the
      // customer visited before starting the MitID flow (usually the cart).
      existing.returnUrl = window.location.pathname + window.location.search + window.location.hash;
      existing.savedAt = Date.now();
      write(existing);
      return;
    }

    if (!source && inferred) source = inferred.source;
    if (!medium && inferred) medium = inferred.medium;
    if (!hasTracking && !inferred) return;

    var tracking = {};
    TRACKING_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) tracking[key] = value;
    });
    if (source && !tracking.utm_source) tracking.utm_source = source;
    if (medium && !tracking.utm_medium) tracking.utm_medium = medium;

    write({
      savedAt: Date.now(),
      returnUrl: window.location.pathname + window.location.search + window.location.hash,
      tracking: tracking
    });
  }

  function repairCallback() {
    if (!trackingAllowed() || new URLSearchParams(window.location.search).has('mitid_error')) return;
    var value = read();
    if (!value || !value.returnUrl) return;

    var target;
    try {
      target = new URL(value.returnUrl, window.location.origin);
    } catch (error) {
      return;
    }
    if (target.origin !== window.location.origin || target.pathname === CALLBACK_PATH) return;

    Object.keys(value.tracking || {}).forEach(function (key) {
      if (!target.searchParams.has(key)) target.searchParams.set(key, value.tracking[key]);
    });

    var store = storage();
    if (store) {
      try { store.removeItem(STORAGE_KEY); } catch (error) {}
    }
    window.location.replace(target.toString());
  }

  function run() {
    if (window.location.pathname === CALLBACK_PATH) {
      // Let the MitID app finish setting its verification state first.
      window.setTimeout(repairCallback, 200);
    } else {
      capture();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
